/**
 * 登录接口响应解析（后端/axios 多层包装兼容，集中在一处维护）
 */

/** @param {object} res 接口原始响应 */
export function resolveAuthPayload (res) {
  const level1 = res?.data
  const level2 = level1?.data
  if (level2 && (level2.token || level2.member || level2.userInfo)) return level2
  if (level1 && (level1.token || level1.member || level1.userInfo)) return level1
  if (res && (res.token || res.member || res.userInfo)) return res
  return {}
}

/** @param {object} responseData resolveAuthPayload 结果 */
export function extractAccessToken (responseData) {
  return responseData?.token?.access_token || responseData?.access_token || responseData?.token
}

/** @param {object} responseData */
export function extractMember (responseData) {
  return responseData?.member || responseData?.userInfo || null
}

/** @param {string} msg */
export function isExpiredMessage (msg) {
  const text = String(msg || '')
  return text.includes('过期') || text.includes('expired')
}
